// @ts-nocheck
/* eslint-disable */
export const appImpersonator24Icon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle opacity="0.5" cx="8" cy="8" r="4" fill="currentColor"/><path d="M8 12C4.13401 12 0.999999 15.134 0.999999 19L15 19C15 15.134 11.866 12 8 12Z" fill="currentColor"/><path d="M18.5 15.5L22 12L18.5 8.5" stroke="currentColor" stroke-width="2"/><path d="M14 12L22 12" stroke="currentColor" stroke-width="2"/></svg>`,
    name: 'impersonator-24' as const
};